import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-private-class',
  templateUrl: './student-private-class.component.html',
  styleUrls: ['./student-private-class.component.css']
})
export class StudentPrivateClassComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
